import React, {useState} from 'react';
import {reduxForm, initialize, SubmissionError, SubmitHandler} from 'redux-form';
import {useDispatch, useSelector} from 'react-redux';

import LoginView from './view';
import {LoginState} from '../../../shared/models/login/loginStep';
import {Forms} from '../../../shared/models/forms';
import {LoginForm} from '../../../shared/models/login';
import {validationPipe} from '../../../shared/pipes';
import {login} from '../../../redux/actions/login';
import {loginResponseSelector} from '../../../redux/selectors/login';
import {setRuntimeLoginStepState} from '../../../redux/actions/runtime/loginStep';
import {profileSessionExpiredSelector} from '../../../redux/selectors/profile';

const getFormErrors = (formData: LoginForm) =>
  validationPipe(formData, [
    {
      names: 'identificator',
      error: 'Обязательное поле',
      type: 'required',
    },
    {
      names: 'password',
      error: 'Обязательное поле',
      type: 'required',
    },
  ]);

export interface Props {
  handleSubmit: SubmitHandler<LoginForm, LoginForm, string>;
}

export const Login_ = (props: Props) => {
  const [submitting, setSubmitting] = useState<boolean>(false);
  const {handleSubmit} = props;

  const dispatch = useDispatch();
  const loginInfo = useSelector(loginResponseSelector());
  const isSessionExpired = useSelector(profileSessionExpiredSelector());

  if (!loginInfo) return null;

  const onMainClick = async (formData: LoginForm) => {
    const submissionError = getFormErrors(formData);
    if (submissionError) {
      throw new SubmissionError(submissionError);
    }

    try {
      setSubmitting(true);
      await dispatch(login(formData.password));
    } finally {
      setSubmitting(false);
    }
  };

  const onForgotPassword = (a: LoginForm) => {
    const {identificator} = a;

    dispatch(initialize(Forms.registrationOrRecoveryForm, {identificator}));
    dispatch(setRuntimeLoginStepState(LoginState.forgotPassword));
  };

  return (
    <LoginView
      isSessionExpired={isSessionExpired}
      onForgotPassword={() => handleSubmit(onForgotPassword)()}
      submitting={submitting}
      onSubmit={(e) => {
        e?.preventDefault();
        handleSubmit(onMainClick)();
      }}
      loginType={loginInfo.loginType}
    />
  );
};

export const Login = reduxForm<any, any>({form: Forms.loginForm})(Login_);
